export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || ''

export const isTestMode =
  String(import.meta.env.VITE_TEST_MODE || '').toLowerCase() === 'true' ||
  String(import.meta.env.VITE_TEST_MODE || '') === '1'
